import { AdviceProductDetailsFormValues } from "../../ProductDetails/FormElements/interfaces";
import { OneTimePaymentAdvisorChoice } from "../../ProductPrice/AdviceCards/interfaces";

export enum AkaAdviceCheckboxes {
  DEATH_CHECKBOX = "deathCheckbox",
  DISABILITY_CHECKBOX = "disabilityCheckbox",
  CRITICAL_ILLNESS_CHECKBOX = "criticalIllnessCheckbox",
}

export interface AkaDeathAdviceFormValues
  extends AkaDeathAdviceCoInsuredFormValues {
  [AkaAdviceCheckboxes.DEATH_CHECKBOX]: boolean;
  akaGroupLifeDeathCheckbox: boolean;
  akaGroupLifeDeathGLevel?: string;
  deathInsuredSumCheckbox: boolean;
  deathInsuredSumSlider?: number;
  deathAdviceComment?: string;
}

interface AkaDeathAdviceCoInsuredFormValues {
  akaGroupLifeDeathCoInsuredCheckbox?: boolean;
  akaGroupLifeDeathCoInsuredGLevel?: string;
}

export interface AkaDisabilityAdviceFormValues
  extends AkaDisabilityAdviceCoInsuredFormValues {
  [AkaAdviceCheckboxes.DISABILITY_CHECKBOX]: boolean;
  incapacityOfWorkCheckbox: boolean;
  incapacityOfWorkGLevel?: string;
  timeLimitedDisabilityInterestCheckbox: boolean;
  timeLimitedDisabilityInterestGLevel?: string;
  disabilityInsuredSumCheckbox: boolean;
  disabilityInsuredSumSlider?: number;
  disabilityPaymentAfter3Months?: boolean;
  disabilityOneTimePaymentCheckbox: boolean;
  disabilityOneTimePaymentValue?: number;
  disabilityOneTimePaymentChangedWarning?: boolean;
  disabilityOneTimePaymentAdvisorChoice?: OneTimePaymentAdvisorChoice;
  disabilityOneTimePaymentAdvisorValue?: number;
  disabilityAdviceComment?: string;
}

interface AkaDisabilityAdviceCoInsuredFormValues {
  incapacityOfWorkCoInsuredCheckbox?: boolean;
  incapacityOfWorkCoInsuredGLevel?: string;
  timeLimitedDisabilityInterestCoInsuredCheckbox?: boolean;
  timeLimitedDisabilityInterestCoInsuredGLevel?: string;
}

export interface AkaCriticalIllnessAdviceFormValues
  extends AkaCriticalIllnessAdviceCoInsuredFormValues {
  [AkaAdviceCheckboxes.CRITICAL_ILLNESS_CHECKBOX]: boolean;
  akaCriticalIllnessCoverageAmountCheckbox: boolean;
  akaCriticalIllnessCoverageAmountGLevel?: string;
  criticalIllnessInsuredSumCheckbox: boolean;
  criticalIllnessInsuredSumSlider?: number;
  criticalIllnessAdviceComment?: string;
}

interface AkaCriticalIllnessAdviceCoInsuredFormValues {
  akaCriticalIllnessCoverageAmountCoInsuredCheckbox?: boolean;
  akaCriticalIllnessCoverageAmountCoInsuredGLevel?: string;
}

export enum SubmitAction {
  DOWNLOAD_ADVICE = "DOWNLOAD_ADVICE",
}

export interface AkaAdvicePriceFormValues
  extends AkaDeathAdviceFormValues,
    AkaDisabilityAdviceFormValues,
    AkaCriticalIllnessAdviceFormValues {
  adviceDiffConsent?: boolean;
}

export interface AkaAdvicePriceFormValuesWithAction
  extends AkaAdvicePriceFormValues {
  submitAction?: SubmitAction;
}

export type AkaAdvisorValues = Pick<
  AdviceProductDetailsFormValues,
  "situationComment"
> &
  Pick<
    AkaAdvicePriceFormValues,
    "deathAdviceComment" | "criticalIllnessAdviceComment"
  > &
  Pick<
    AkaDisabilityAdviceFormValues,
    | "disabilityAdviceComment"
    | "disabilityPaymentAfter3Months"
    | "disabilityOneTimePaymentAdvisorChoice"
    | "disabilityOneTimePaymentAdvisorValue"
  >;
